import { render, staticRenderFns } from "./About.vue?vue&type=template&id=6fc1d69f&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=6fc1d69f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc1d69f",
  null
  
)

export default component.exports